<template>   
    <Modal> 
        <template #title>
        {{ props.titleTxt}}
        </template>

        <template #body>
        {{ props.bodyTxt}}
        </template>

        <template #footer>
            <button
                type="button" 
                class="btn btn-light" 
                @click="onCancle"
            >
                취소
            </button>
            <button 
                type="button" 
                class="btn btn-danger"
                @click="onOk"
            >
                확인
            </button>
        </template>     
    </Modal>
    
</template>

<script>
import Modal from "@/components/popups/Modal.vue"
export default {
  components:{
      Modal
  },
  props:{
    titleTxt:{
           type:String,
           require:true
    },
    bodyTxt:{
           type:String,
           require:true
    },
  },
  emits:['cancle', 'ok'],
  setup(props, {emit}){
  
     
     const onCancle = () =>{
      
        emit('cancle')
     }

     const onOk = () =>{
        emit('ok')
     }
     
     return {
         onCancle,
         onOk,
         props,
        
     }
   }

}
</script>

<style>

</style>